import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import WeatherTemperatureUnit from 'owa-service/lib/contract/WeatherTemperatureUnit';
import type { WeatherDetailsViewProps } from '../schema';
import {
    weatherAssetDegreesCelsius,
    weatherAssetDegreesFahrenheit,
} from '../weather.locstring.json';
import loc from 'owa-localize';

const spriteStyles = require('owa-sprite/dist/styles/weatherFlat_sprite.css');
const iconClassPrefix = 'weatherFlat-icon-SkyCode_';

export default observer(function WeatherDetailsView({
    temp,
    skyCode,
    skyText,
    tempUnit,
}: WeatherDetailsViewProps) {
    const iconClass = spriteStyles[iconClassPrefix + (skyCode || 0)];
    const degreesString =
        tempUnit === WeatherTemperatureUnit.Celsius
            ? weatherAssetDegreesCelsius
            : weatherAssetDegreesFahrenheit;

    return (
        <div className={styles.weatherIcon}>
            <figure className={styles.weatherSkyCodeIconFigure} title={skyText}>
                <i className={classNames(styles.weatherSkyCodeIcon, iconClass)} />
            </figure>
            <div className={styles.temp}>{loc(degreesString, temp)}</div>
            <div>{skyText}</div>
        </div>
    );
});
